import React from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import Typography from '@material-ui/core/Typography'
import { WID } from '../../../constants/Language';
import Word from '../../../containers/Common/Word'
import CustomAvatar from '../../../Parts/CustomAvatar/CustomAvatar'

const styles = theme => ({
  user: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing.unit
  },
  avatarPrimary: {
    margin: theme.spacing.unit,
    fontSize: '1em',
    backgroundColor: theme.palette.primary.light,
  },
})

class UserListDialog extends React.Component {  
  render() {
    const { classes, open, users, handleClose } = this.props
    var avatar
    return (
      <div>
        <Dialog
          open={open}
          onClose={handleClose}
        >
          <DialogTitle><Word wid={WID.USER_LIST_DIALOG.DIALOG_TITLE}/></DialogTitle>
          <DialogContent>
            {users && users.map((user,index) => {
              if (user.photoURL) {
                avatar = (<CustomAvatar className={classes.avatar} name={user.displayName} src={user.photoURL}/>)
              }
              else if (!user.photoURL && user.displayName && !user.displayName.match(/guest[0-9]*/)) {
                avatar = (<Avatar className={classes.avatarPrimary}>{user.displayName[0].toUpperCase()}</Avatar>)
              }
              else if (!user.photoURL && user.displayName && user.displayName.length > 0) {
                avatar = (<CustomAvatar className={classes.avatar} name={user.displayName}/>)
              }
              else {
                avatar = (<Avatar className={classes.avatar}></Avatar>)
              }
              return (
                <div className={classes.user} key={index}>
                  {avatar}
                  <div>
                    <Typography>{user.displayName}</Typography>
                  </div>
                </div>
              )
            })}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose} color="primary">Close</Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(UserListDialog)


// WEBPACK FOOTER //
// ./src/components/Common/Chat/UserListDialog.js